import React from "react";
import { Modal } from "react-bootstrap";
import CommentPanel from "../execution/components/CommentPanel";

const CommentsModal = ({
    show,
    onClose,
    comments,
    onAddComment,
    title = "Comments",
}) => {

    return (
        <Modal
            show={show}
            onHide={onClose}
            size="lg"
            centered
        >
            <Modal.Header className="border-bottom bg-light">

                <Modal.Title>{title}</Modal.Title>

                <button
                    type="button"
                    onClick={onClose}
                    style={{
                        marginLeft: "auto",
                        border: "none",
                        background: "transparent",
                        fontSize: "1.5rem",
                        fontWeight: "bold",
                        cursor: "pointer",
                        lineHeight: 1,
                        color: "#000"
                    }}
                >
                    ×
                </button>

            </Modal.Header>

            <Modal.Body style={{ padding: 0 }}>
                <CommentPanel
                    comments={comments}
                    onAddComment={onAddComment}
                />
            </Modal.Body>
        </Modal>
    );

};

export default CommentsModal;